import { types } from 'mobx-state-tree';
var BottomSheetStore = types
    .model({
    activeBottomSheetKey: types.maybe(types.string)
})
    .named('BottomSheetStore')
    .volatile(function (_) { return ({
    activeParameters: undefined,
    previousBottomSheets: []
}); })
    .views(function (self) { return ({
    isOpen: function (bottomSheetKey) {
        return self.activeBottomSheetKey === bottomSheetKey;
    },
    getActiveParameters: function (bottomSheetKey) {
        if (!this.isOpen(bottomSheetKey)) {
            return undefined;
        }
        return self.activeParameters;
    }
}); })
    .actions(function (self) { return ({
    openBottomSheet: function (bottomSheetKey, parameters) {
        // store the opened bottom sheet
        if (self.activeBottomSheetKey) {
            self.previousBottomSheets.push({
                key: self.activeBottomSheetKey,
                parameters: self.activeParameters
            });
        }
        // open the bottom sheet
        self.activeBottomSheetKey = bottomSheetKey;
        self.activeParameters = parameters;
    },
    closeBottomSheet: function () {
        var latestPrevious = self.previousBottomSheets.pop();
        if (latestPrevious) {
            self.activeBottomSheetKey = latestPrevious.key;
            self.activeParameters = latestPrevious.parameters;
            return;
        }
        self.activeBottomSheetKey = undefined;
        self.activeParameters = undefined;
    }
}); });
export default BottomSheetStore;
//# sourceMappingURL=BottomSheetStore.js.map